import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import TableHeader from './components/TableHeader/TableHeader';
import TableRow from './components/TableRow/TableRow';
import PulseLoader from 'react-spinners/PulseLoader';
import './styles.scss';

const TableList = (props) => {
  const {
    columnList,
    sortedItem,
    onSortHandler,
    dataList,
    customRendering,
    selectButtonHandler = () => {
      //Default value for selectButtonHandler function
    },
    clickHandler,
    handleClickNavigate,
    pageNumber,
    loadMore,
    totalPages,
    totalItems,
    emptySearchMessage,
    searchKey,
    accordionColumns,
    isMobile,
  } = props;
  const [hasMoreitems, setHasMoreItems] = React.useState(true);

  const override = `
  display: block;
  margin: 0 auto;
  border-color: red;
  text-align: center;
`;
  return (
    !!columnList &&
    columnList.length > 0 && (
      <div className="table-list-container">
        {(totalPages >=0 ) && (
          <TableHeader
            columns={columnList}
            onSortHandler={(sortBy) => {
              if (sortedItem.sortField === sortBy.sortField) {
                onSortHandler(sortBy);
              }
            }}
            sortedItem={sortedItem}
          />
        )}

        {totalPages > 0 && (
          <div id="scrollableDiv" className="container-scroll">
            <InfiniteScroll
              dataLength={dataList && dataList.length}
              next={() => {
                if (
                  totalItems === dataList.length ||
                  dataList.length > totalItems ||
                  pageNumber === totalPages
                ) {
                  setHasMoreItems(false);
                }
                loadMore();
              }}
              hasMore={hasMoreitems}
              scrollableTarget="scrollableDiv"
              loader={
                pageNumber <= totalPages && totalPages > 1 ? (
                  <div
                    className="loading"
                    style={{ marginBottom: 24, marginTop: 24 }}
                  >
                    <PulseLoader color={'#ffffff'} css={override} />
                  </div>
                ) : null
              }
            >
              {!!dataList &&
                dataList.data === undefined &&
                dataList.map((data, index) => (
                  <TableRow
                    indexKey={index}
                    key={data.email}
                    dataRow={data}
                    columns={columnList}
                    customRendering={customRendering}
                    selectButtonHandler={selectButtonHandler.bind(this, data)}
                    clickHandler={clickHandler}
                    handleClickNavigate={handleClickNavigate}
                    accordionColumns={accordionColumns}
                    isMobile={isMobile}
                  />
                ))}
            </InfiniteScroll>
          </div>
        )}
        {totalPages === 0 && searchKey.length > 0 && (
          <div className="empty-container">
            <span style={{ fontWeight: 600 }}>{emptySearchMessage.error}</span>{' '}
            &nbsp;
            {emptySearchMessage.msg}
          </div>
        )}
      </div>
    )
  );
};

export default TableList;
